export const COMPLETE_REGISTRATION_VIDEO_SOURCES = [
  { src: '/videos/auth/complete-registration/complete-registration-ios.mov', type: 'video/quicktime' },
  { src: '/videos/auth/complete-registration/complete-registration.webm', type: 'video/webm' },
];

export const COMPLETE_REGISTRATION_VIDEO_POSTER = '/videos/auth/complete-registration/complete-registration-poster.webp';
